import React from 'react'
import useHotels from '../../../hooks/useHotels'
import logo from '../../../images/logo2.png'
import Header from '../../Shared/Header/Header'
import LoadingSpinner from '../../Shared/LoadingSpinner/LoadingSpinner'
import CoxHotels from './CoxHotels'
import SajekHotels from './SajekHotels'
import SreemangalHotels from './SreemangalHotels'
import SundarbanHotels from './SundarbanHotels'

const AllDestinations = () => {
    const [hotels, loading] = useHotels()

    return (
        <>
            <Header>{logo}</Header>
            <div>
                {
                    loading ? <LoadingSpinner/> : 
                    <>
                        <h1 className='text-3xl text-center text-sky-700 font-semibold'>Hotels in Cox's Bazar</h1>
                        <CoxHotels hotels={hotels.slice(0,3)}/>
                        <h1 className='text-3xl text-center text-sky-700 font-semibold'>Hotels in Sreemangal</h1>
                        <SreemangalHotels hotels={hotels.slice(3,6)}/>
                        <h1 className='text-3xl text-center text-sky-700 font-semibold'>Hotels in Sundarban</h1>
                        <SundarbanHotels hotels={hotels.slice(6,9)}/> 
                        <h1 className='text-3xl text-center text-sky-700 font-semibold'>Hotels in Sajek</h1>
                        <SajekHotels hotels={hotels.slice(9, 12)}/>
                    </>
                }
            </div>
        </>
    );
};

export default AllDestinations;